import { EventEmitter, Injectable, Input} from '@angular/core';
import { Brand } from 'src/models/brand';
import { NavbarMenu } from 'src/models/navbarMenu';
import { User } from 'src/models/user';
import { APIMenuService } from './api-services/api-menu-service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GetTokenService } from './incadea/incadea-services/getToken.service';
import {  BehaviorSubject, catchError, map, Observable, Subject } from 'rxjs';
import { incadeaConfig } from 'src/environments/environment';
import { APIUserManagamentService } from './api-services/api-user-Management';
import { AppComponent } from 'src/app/app.component';
import { APIPingIdservice } from './Apigee/PingIdToken';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})

export class HelperService {
  public modules: NavbarMenu[] = [];
  public user: User = {} as User;
  public brand: Brand = {} as Brand
  public filterType?: string
  public retailId: number =0
  public token: BehaviorSubject<string> = new BehaviorSubject<string>('')
  public userRetrieve = new EventEmitter();
  public userId?: number;
  public countryIdWebView?: number;
  constructor(
    public menuService: APIMenuService,
    private router: Router,
    private translate: TranslateService,
    private getTokenService: GetTokenService,
    private UserManagamentService:APIUserManagamentService,private PingIdservice:APIPingIdservice

  ) {

          this.getUserDetailsFromService();
      

  
  }

  public TitlePage: string = "scheduling"
  public icon: string = "calendar_month"
  public typeAlert:string =""
  public messageAlert:string =""
  public showAlert:boolean =false
  public TokenBooking:string =""
  public userEmail:string =""
  public cancelacion_citas:boolean =false
  public checkbokMix:number =0
  private keyEncription ='uY+Qv4pRr9ZCzGxvL0c8A4R6xWmZpYH2GZx4cZqN8Qo=';
  public siteKeyCatcha = '6LfGhpMrAAAAAIQUW1kQT3Zh_wSR_qUAHAoj86ek'
  ngOnInit(): void {
  

  }



  getUserDetailsFromService() {
  const encryptedEmail = this.getCookie('Email');

  if (!encryptedEmail) {
    console.warn('Cookie Email no encontrada');
    return;
  }

  this.userEmail = this.decrypt(encryptedEmail);

  if (!this.userEmail) {
    console.error('Error al desencriptar Email');
  }

     
    if (this.userEmail != '' && !window.location.href.toLowerCase().includes('webview')) {

      this.loginPingId().subscribe({
            next: (token) => {
            
               this.menuService?.get(this.userEmail,this.TokenBooking,this.checkbokMix).subscribe({
        next: (response) => {
          // console.log(response);

          if (response.userdata.role.roleId===1) {

            this.userId = response.userdata.advisorId
          }
         
          this.modules = response.modules;

          this.user = response.userdata
          this.brand = response.color[0]

          if (response.userdata.isIncadea === "1") {
            this.getTokenService.getToken().subscribe(
              { next: (responseUserData)=>{
              this.token.next(responseUserData.access_token)

              // As it's a POST service it doesnt require unsubscribe
              }}
              );
          }

          this.translate.use(response['userdata'].language);

          // API is currently returns array of Brand but for now let's used the first Brand by default
          this.userRetrieve.emit();
        },
        error: (error) => {

          if(error.status === 401){
            this.logoutToken()
          }
           if(error.status === 400){
           this.translate.use("es-CO");
            this.userRetrieve.emit("sessionFailed");
            this.router.navigate(['sessionFailed']);
          }
          console.error("cant retrieve User exception", error);
        }
      });
            },
            error: (error) => {
              console.error('Error al obtener el token:', error);
            },
          });
     
    } else if(!window.location.href.toLowerCase().includes('webview')) {
      this.router.navigate(['login']);

    }




    // funciones para deshabilitar el login

    // Perfiles: Usar para cambiar de rol

    // 1    ServiceAdvisorProfile@inchcape.com    Service    Advisor
    // 2    WorkshopSuperAdmin@inchcape.com    Workshop    Super Admin
    // 3    ContactCenterAdvisor@inchcape.com    Contact    Center
    // 4    SuperRetailGroupAdministrator@inchcape.com    Retail Group    Admin    z
    // 5    BrandingConsultant@inchcape.com    Branding    Consultant    
    // 6    workshopAssistant@inchcape.com    workshopAssistant
    // 7    superAdminSupport@inchcape.com    SuperAdminSuppot

    // Roles Incadea

    // incadea.booking@inchcape.com
    // incadea.booking.contact@inchcape.com

    // let userEmail = sessionStorage.getItem('userEmail') || 'SuperRetailGroupAdministrator@inchcape.com';
    // this.menuService?.get(userEmail).subscribe( {
    //   next: (response) => {
    //     if (response['userdata']['role'].roleName==='Service Advisor') {

    //       this.userId=response['userdata'].advisorId
    //     } else {
    //     }
    //     this.modules = response['modules'];
    //     this.user = response['userdata'] as User;
    //     this.brand = response['color'][0] as Brand;
    //     this.translate.use(response['userdata'].language);
    //     // API is currently returns array of Brand but for now let's used the first Brand by default
    //     this.userRetrieve.emit();
    //   },
    //   error: (error) => {
    //     console.error("handled user exception, no user Found", error)
    //   }
    // });
  }

  loginPingId(): Observable<string> {
    
     return this.PingIdservice?.getTokenPingId().pipe(
      map((response) => {
        this.TokenBooking = response.access_token;
     
        return this.TokenBooking;
      }),
      catchError((error) => {
        console.error("Can't retrieve User exception", error);
        return ''; // Devuelve un observable con un valor vacío en caso de error
      })
    );
  }

 decrypt(encryptedBase64: string): string {

  const raw = CryptoJS.enc.Base64.parse(encryptedBase64);

  // 16 bytes = 128 bits
  const iv = CryptoJS.lib.WordArray.create(
    raw.words.slice(0, 4),
    16
  );

  const cipherText = CryptoJS.lib.WordArray.create(
    raw.words.slice(4),
    raw.sigBytes - 16
  );

  const key = CryptoJS.enc.Base64.parse(this.keyEncription);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: cipherText } as any,
    key,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
}

  // loginwebview(): Observable<string> {
  //   const dataLogin = {
  //     username: "WebviewUser@Booking.com",
  //     password: "1234567890",
  //   };

  //   return this.UserManagamentService?.LoginBooking(dataLogin).pipe(
  //     map((response) => {
  //       this.TokenBooking = response.token;

  //       return this.TokenBooking;
  //     }),
  //     catchError((error) => {
  //       console.error("Can't retrieve User exception", error);
  //       return ''; // Devuelve un observable con un valor vacío en caso de error
  //     })
  //   );
  // }

  logoutToken(){
    this.deleteCookie("Email")
    this.deleteCookie("AuthToken")
    this.userRetrieve.emit("error");
    this.router.navigate(['login']);
    const translateText=this.translate.instant('NotTimeAvailabilityError')
    this.showAlert =true
    this.typeAlert ="warning"
    this.messageAlert ="Expired Session"
    setTimeout(() => {
      this.showAlert =false

      }, 7000)
  }


  ChangeUserMix() {
   const encryptedEmail = this.getCookie('Email');

  if (!encryptedEmail) {
    console.warn('Cookie Email no encontrada');
    return;
  }

  this.userEmail = this.decrypt(encryptedEmail);

  if (!this.userEmail) {
    console.error('Error al desencriptar Email');
  }
  
    this.menuService?.get(this.userEmail,this.TokenBooking,this.checkbokMix).subscribe({
      next: (response) => {
        // console.log(response);

        if (response.userdata.role.roleId===1) {

          this.userId = response.userdata.advisorId
        }

        this.modules = response.modules;

        this.user = response.userdata
        this.brand = response.color[0]


 if (response.userdata.isIncadea === "1") {
  this.getTokenService.getToken().subscribe(
    { next: (responseUserData)=>{
     this.token.next(responseUserData.access_token)

     // As it's a POST service it doesnt require unsubscribe
    }}
     );
 }

        this.translate.use(response['userdata'].language);

        // API is currently returns array of Brand but for now let's used the first Brand by default
        this.userRetrieve.emit();
      },
      error: (error) => {
        if(error.status === 401){
          this.logoutToken()
        }
        console.error("cant retrieve User exception", error);
      }
    })

  }
  private getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;
    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
   deleteCookie(name: string) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}
